export default "__VITE_ASSET__B7s8quvE__"